
<div class="change-password-wrapper">
  @if (headerLayout === 'applicant') {
    <app-common-header
  *ngIf="headerLayout === 'applicant'"

  [headerLayout]="'applicant'"
  [logoSrc]="logoApplicantSrc"
  [userNameData]="userNameData"
  [profileImageSrc]="profileImageSrc"
  [profileImageClass]="profileImageClass"
  [showProfileMenu]="showProfileMenuOfApplication"
  [onEditProfile]="goToEditProfile"
  [onChangePassword]="goToChangePassword"
  [onLogout]="onSignOutClick"
  (sealIconClick)="onGeoPermitLogoClick()">
</app-common-header>
  }
<div class="content">
<div class="back-link" (click)="onBack()">
  <wm-common-text
    [data]="{ text: '< Back', fontFamily: 'roboto' }">
  </wm-common-text>
</div> 
<div class="title-container">
  <wm-common-text
    [data]="{ text: 'Change Password', fontFamily: 'roboto' }">
  </wm-common-text>
</div>
  <form class="form-section" [formGroup]="form">

    <wm-common-textfield
      [data]="{
        label: 'Current Password',
        type: 'password',
        required: true,
        helperText: currentPasswordError
      }"
      formControlName="currentPassword">
    </wm-common-textfield>

    <wm-common-textfield
      [data]="{
        label: 'New Password',
        type: 'password',
        required: true,
        helperText: newPasswordError
      }"
      formControlName="newPassword">
    </wm-common-textfield>

    <wm-common-textfield
      [data]="{
        label: 'Confirm Password',
        type: 'password',
        required: true,
        helperText: confirmPasswordError
      }"
      formControlName="confirmPassword">
    </wm-common-textfield>

  </form>

  <div class="button-row">
    <wm-common-button
      class="cancel-btn"
      [data]="{ text: 'CANCEL', onClick: onCancel }">
    </wm-common-button>

    <wm-common-button
      class="save-btn"
      [data]="{ text: 'SAVE', onClick: onSave }">
    </wm-common-button>
  </div>
  </div>

</div>
<wm-common-confirmation-modal
  [data]="saveAndExitModalData"
  (onOkClick)="handleSaveAndExit()"
  (onYesClick)="handleSaveAndExit()"
  (onNoClick)="saveAndExitcloseModal()"
  (onCloseClick)="saveAndExitcloseModal()">
</wm-common-confirmation-modal>

<!-- added by omkar on 18/03/2026 -->
<wm-common-confirmation-modal
  [data]="signOutModalData"
  (onYesClick)="handleSignOutModalAccepted()"
  (onNoClick)="handleSignOutModalRejected()"
>
</wm-common-confirmation-modal>
<!-- end by omkar on 18/03/2026 -->

